// @ts-nocheck
/**
 * @generated
 * @file HomepageHowItWorks (generated by DevLink)
 *
 * This file is generated by DevLink from a Webflow component. Manual edits are discouraged.
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
"use client";

import { DEVLINK_SCOPE_CLASS } from "./devlinkScope";
import Block from "./webflow_modules/Basic/components/Block";
import BlockContainer from "./webflow_modules/Layout/components/BlockContainer";
import DOM from "./webflow_modules/Builtin/components/DOM";
import Heading from "./webflow_modules/Basic/components/Heading";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import Section from "./webflow_modules/Layout/components/Section";
import TabsContent from "./webflow_modules/Tabs/components/TabsContent";
import TabsLink from "./webflow_modules/Tabs/components/TabsLink";
import TabsMenu from "./webflow_modules/Tabs/components/TabsMenu";
import TabsPane from "./webflow_modules/Tabs/components/TabsPane";
import TabsWrapper from "./webflow_modules/Tabs/components/TabsWrapper";

/**
 * Props for {@link HomepageHowItWorks}
 */
export type HomepageHowItWorksProps = {
  chooseYourMembershipContent?: Record<string, unknown>;
  image1?: string;
  image2?: string;
  image3?: string;
  image4?: string;
  image5?: string;
  image6?: string;
  image7?: string;
  image8?: string;
  link1?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  link2?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  link4?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  teamsOnTheGroundDoTheWork?: Record<string, unknown>;
  teamsOnTheGroundDoTheWorkContent?: Record<string, unknown>;
  text?: React.ReactNode;
  text10?: React.ReactNode;
  text11?: React.ReactNode;
  text12?: React.ReactNode;
  text13?: React.ReactNode;
  text14?: React.ReactNode;
  text15?: React.ReactNode;
  text16?: React.ReactNode;
  text2?: React.ReactNode;
  text3?: React.ReactNode;
  text4?: React.ReactNode;
  text5?: React.ReactNode;
  text6?: React.ReactNode;
  text7?: React.ReactNode;
  text8?: React.ReactNode;
  text9?: React.ReactNode;
  title1?: React.ReactNode;
  title2?: React.ReactNode;
  trackYourImpact?: Record<string, unknown>;
  trackYourImpactContent?: Record<string, unknown>;
};

/**
 * HomepageHowItWorks
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
export function HomepageHowItWorks({
  chooseYourMembershipContent = {},
  image1 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026fb9f8e0a5d503f4b64_Frame%20229%20(1).webp",
  image2 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026fb9f8e0a5d503f4b53_Frame%20228.avif",
  image3 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026fb9f8e0a5d503f4b5c_Frame%20229.webp",
  image4 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026fb9f8e0a5d503f4b4e_arrow-narrow-up-right%20(1).png",
  image5 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026fb9f8e0a5d503f4b64_Frame%20229%20(1).webp",
  image6 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026fb9f8e0a5d503f4b53_Frame%20228.avif",
  image7 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026fb9f8e0a5d503f4b5c_Frame%20229.webp",
  image8 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026fb9f8e0a5d503f4b4e_arrow-narrow-up-right%20(1).png",

  link1 = {
    href: "https://www.sumthing.org/membership",
  },

  link2 = {
    href: "/membership",
  },

  link4 = {
    href: "https://resources.sumthing.org/about/business-model",
  },

  teamsOnTheGroundDoTheWork = {},
  teamsOnTheGroundDoTheWorkContent = {},
  text = "Choose your membership",
  text10 = "Decide on the difference you want to make, from €9,50 / month.",
  text11 = "Teams on the ground do the work",
  text12 = "Decide on the difference you want to make, from €9,50 / month.",
  text13 = "Track your impact",
  text14 = "See proof of your contribution through photos, video, GPS and updates from the field.",
  text15 = "become a member",
  text16 = "84% of your contribution goes directly to impact",
  text2 = "Decide on the difference you want to make, from €9,50 / month.",
  text3 = "Teams on the ground do the work",
  text4 = "From planting corals and creating wildlife corridors, to removing plastic from rivers.",
  text5 = "Track your impact",
  text6 = "See proof of your contribution through photos, video, GPS and updates from the field.",
  text7 = "become a member",
  text8 = "84% of your contribution goes directly to impact",
  text9 = "Choose your membership",
  title1 = "How it works",
  title2 = "How it works",
  trackYourImpact = {},
  trackYourImpactContent = {},
}: HomepageHowItWorksProps) {
  return (
    <div
      className={DEVLINK_SCOPE_CLASS}
      style={{
        display: "contents",
      }}
    >
      <Section
        className={"how-it-works-section"}
        grid={{
          type: "section",
        }}
        tag={"section"}
      >
        <BlockContainer
          className={"container-main"}
          grid={{
            type: "container",
          }}
          tag={"div"}
        >
          <Block className={"mobile-how-it-works"} tag={"div"}>
            <Heading className={"h2"} tag={"h2"}>
              {title1}
            </Heading>
            <Block
              className={"auto-tabs-content-inner is-right-align"}
              tag={"div"}
            >
              <Block className={"auto-tabs-animate-from-right"} tag={"div"}>
                <Image
                  alt={""}
                  className={"image-in-auto-tab"}
                  height={"auto"}
                  loading={"lazy"}
                  src={image1}
                  width={"auto"}
                />
              </Block>
            </Block>
            <Block
              className={"auto-tabs-menu mobile-progrewssbar-hide"}
              tag={"div"}
            >
              <Block className={"auto-tabs-link"} tag={"div"}>
                <Block
                  className={"auto-tabs-number-wrapper mobile"}
                  tag={"div"}
                >
                  <Block className={"auto-tabs-number-inner"} tag={"div"}>
                    {"01"}
                  </Block>
                </Block>
                <Block className={"auto-tabs-link-titel"} tag={"div"}>
                  <Block className={"h5"} tag={"div"}>
                    {text9}
                  </Block>
                </Block>
                <Block className={"auto-tabs-description"} tag={"div"}>
                  <Block className={"overflow-hidden"} tag={"div"}>
                    <Paragraph className={"body-medium"}>{text10}</Paragraph>
                  </Block>
                </Block>
              </Block>
            </Block>
            <Block
              className={"auto-tabs-content-inner is-right-align"}
              tag={"div"}
            >
              <Block className={"auto-tabs-animate-from-right"} tag={"div"}>
                <Image
                  alt={""}
                  className={"image-in-auto-tab"}
                  height={"auto"}
                  loading={"lazy"}
                  src={image2}
                  width={"auto"}
                />
              </Block>
            </Block>
            <Block
              className={"auto-tabs-menu mobile-progrewssbar-hide"}
              tag={"div"}
            >
              <Block className={"auto-tabs-link"} tag={"div"}>
                <Block
                  className={"auto-tabs-number-wrapper mobile"}
                  tag={"div"}
                >
                  <Block className={"auto-tabs-number-inner"} tag={"div"}>
                    {"02"}
                  </Block>
                </Block>
                <Block className={"auto-tabs-link-titel"} tag={"div"}>
                  <Block className={"h5"} tag={"div"}>
                    {text11}
                  </Block>
                </Block>
                <Block className={"auto-tabs-description"} tag={"div"}>
                  <Block className={"overflow-hidden"} tag={"div"}>
                    <Paragraph className={"body-medium"}>{text12}</Paragraph>
                  </Block>
                </Block>
              </Block>
            </Block>
            <Block className={"auto-tabs-content-inner"} tag={"div"}>
              <Block className={"auto-tabs-animate-from-left"} tag={"div"}>
                <Image
                  alt={""}
                  className={"image-in-auto-tab"}
                  height={"auto"}
                  loading={"lazy"}
                  src={image3}
                  width={"auto"}
                />
              </Block>
            </Block>
            <Block
              className={"auto-tabs-menu mobile-progrewssbar-hide"}
              tag={"div"}
            >
              <Block className={"auto-tabs-link"} tag={"div"}>
                <Block
                  className={"auto-tabs-number-wrapper mobile"}
                  tag={"div"}
                >
                  <Block className={"auto-tabs-number-inner"} tag={"div"}>
                    {"03"}
                  </Block>
                </Block>
                <Block className={"auto-tabs-link-titel"} tag={"div"}>
                  <Block className={"h5"} tag={"div"}>
                    {text13}
                  </Block>
                </Block>
                <Block className={"auto-tabs-description"} tag={"div"}>
                  <Block className={"overflow-hidden"} tag={"div"}>
                    <Paragraph className={"body-medium"}>{text14}</Paragraph>
                  </Block>
                </Block>
              </Block>
            </Block>
            <Block
              className={"how-it-works-become-a-member-wrapper"}
              tag={"div"}
            >
              <Link
                button={true}
                className={"button-yellow-full"}
                options={link1}
              >
                {text15}
              </Link>
              <Block className={"contribution-allocation-link"} tag={"div"}>
                <Block className={"bodysmall"} tag={"div"}>
                  <Link
                    button={false}
                    className={"italics-link-green"}
                    options={{
                      href: "#",
                      target: "_blank",
                    }}
                  >
                    {text16}
                  </Link>
                </Block>
                <Image
                  alt={""}
                  className={"arrow-up"}
                  height={"auto"}
                  loading={"lazy"}
                  src={image4}
                  width={"auto"}
                />
              </Block>
            </Block>
          </Block>
          <Block className={"auto-tabs-component hide-on-mobile"} tag={"div"}>
            <TabsWrapper
              className={"auto-tabs-wrapper"}
              current={"Tab 1"}
              easing={"ease"}
              fadeIn={800}
              fadeOut={400}
            >
              <TabsContent className={"auto-tabs-content"} tag={"div"}>
                <TabsPane
                  className={"auto-tabs-content-item"}
                  data-w-tab={"Tab 1"}
                  tag={"div"}
                >
                  <Block
                    className={"auto-tabs-content-inner is-right-align"}
                    tag={"div"}
                  >
                    <Block
                      className={"auto-tabs-animate-from-right"}
                      tag={"div"}
                    >
                      <Image
                        alt={""}
                        className={"image-in-auto-tab"}
                        height={"auto"}
                        loading={"lazy"}
                        src={image5}
                        width={"auto"}
                      />
                    </Block>
                  </Block>
                </TabsPane>
                <TabsPane
                  className={"auto-tabs-content-item"}
                  data-w-tab={"Tab 2"}
                  tag={"div"}
                >
                  <Block
                    className={"auto-tabs-content-inner is-right-align"}
                    tag={"div"}
                  >
                    <Block
                      className={"auto-tabs-animate-from-right"}
                      tag={"div"}
                    >
                      <Image
                        alt={""}
                        className={"image-in-auto-tab"}
                        height={"auto"}
                        loading={"lazy"}
                        src={image6}
                        width={"auto"}
                      />
                    </Block>
                  </Block>
                </TabsPane>
                <TabsPane
                  className={"auto-tabs-content-item"}
                  data-w-tab={"Tab 3"}
                  tag={"div"}
                >
                  <Block className={"auto-tabs-content-inner"} tag={"div"}>
                    <Block
                      className={"auto-tabs-animate-from-left"}
                      tag={"div"}
                    >
                      <Image
                        alt={""}
                        className={"image-in-auto-tab"}
                        height={"auto"}
                        loading={"lazy"}
                        src={image7}
                        width={"auto"}
                      />
                    </Block>
                  </Block>
                </TabsPane>
              </TabsContent>
              <TabsMenu className={"auto-tabs-menu"} tag={"div"}>
                <TabsLink
                  block={"inline"}
                  className={"auto-tabs-link"}
                  data-auto-tabs={"link"}
                  data-w-tab={"Tab 1"}
                >
                  <Block className={"auto-tabs-number-wrapper"} tag={"div"}>
                    <Block className={"auto-tabs-number-inner"} tag={"div"}>
                      {"01"}
                    </Block>
                  </Block>
                  <Block className={"auto-tabs-link-titel"} tag={"div"}>
                    <Block className={"h5"} tag={"div"}>
                      {text}
                    </Block>
                  </Block>
                  <Block className={"auto-tabs-description"} tag={"div"}>
                    <Block className={"overflow-hidden"} tag={"div"}>
                      <Paragraph
                        className={"body-medium"}
                        {...chooseYourMembershipContent}
                      >
                        {text2}
                      </Paragraph>
                    </Block>
                  </Block>
                  <Block
                    className={"auto-tabs-progress-bar"}
                    data-auto-tabs={"bar"}
                    tag={"div"}
                  />
                </TabsLink>
                <TabsLink
                  block={"inline"}
                  className={"auto-tabs-link"}
                  data-auto-tabs={"link"}
                  data-w-tab={"Tab 2"}
                >
                  <Block className={"auto-tabs-number-wrapper"} tag={"div"}>
                    <Block className={"auto-tabs-number-inner"} tag={"div"}>
                      {"02"}
                    </Block>
                  </Block>
                  <Block className={"auto-tabs-link-titel"} tag={"div"}>
                    <Block className={"overflow-hidden"} tag={"div"}>
                      <Block
                        className={"h5"}
                        tag={"div"}
                        {...teamsOnTheGroundDoTheWork}
                      >
                        {text3}
                      </Block>
                    </Block>
                  </Block>
                  <Block className={"auto-tabs-description"} tag={"div"}>
                    <Block className={"overflow-hidden"} tag={"div"}>
                      <Paragraph
                        className={"body-medium"}
                        {...teamsOnTheGroundDoTheWorkContent}
                      >
                        {text4}
                      </Paragraph>
                    </Block>
                  </Block>
                  <Block
                    className={"auto-tabs-progress-bar"}
                    data-auto-tabs={"bar"}
                    tag={"div"}
                  />
                </TabsLink>
                <TabsLink
                  block={"inline"}
                  className={"auto-tabs-link"}
                  data-auto-tabs={"link"}
                  data-w-tab={"Tab 3"}
                >
                  <Block className={"auto-tabs-number-wrapper"} tag={"div"}>
                    <Block className={"auto-tabs-number-inner"} tag={"div"}>
                      {"03"}
                    </Block>
                  </Block>
                  <Block className={"auto-tabs-link-titel"} tag={"div"}>
                    <Block className={"h5"} tag={"div"} {...trackYourImpact}>
                      {text5}
                    </Block>
                  </Block>
                  <Block className={"auto-tabs-description"} tag={"div"}>
                    <Block className={"overflow-hidden"} tag={"div"}>
                      <Paragraph
                        className={"body-medium"}
                        {...trackYourImpactContent}
                      >
                        {text6}
                      </Paragraph>
                    </Block>
                  </Block>
                  <Block
                    className={"auto-tabs-progress-bar"}
                    data-auto-tabs={"bar"}
                    tag={"div"}
                  />
                </TabsLink>
              </TabsMenu>
            </TabsWrapper>
            <DOM
              className={"auto-tabs-button"}
              data-auto-tabs={"button"}
              data-auto-tabs-button={"play"}
              tag={"button"}
              type={"button"}
            >
              <Block
                className={"auto-tabs-button-inner"}
                data-auto-tabs-button={"play-icon"}
                tag={"div"}
              >
                <Block className={"auto-tabs-icon"} tag={"div"}>
                  <Block className={"icon-component"} tag={"div"}>
                    <DOM
                      className={"video-icon"}
                      fill={"none"}
                      tag={"svg"}
                      viewBox={"0 0 16 19"}
                      width={"100%"}
                      xmlns={"http://www.w3.org/2000/svg"}
                    >
                      <DOM
                        d={
                          "M0 2.58066C0 0.787379 1.98386 -0.295707 3.49233 0.674023L14.0338 7.45071C15.4217 8.34294 15.4217 10.3718 14.0338 11.264L3.49233 18.0407C1.98386 19.0104 0 17.9273 0 16.134V2.58066Z"
                        }
                        fill={"currentColor"}
                        tag={"path"}
                      />
                    </DOM>
                  </Block>
                </Block>
                <Block className={"auto-tabs-button-text"} tag={"div"}>
                  {"Start autoplay"}
                </Block>
              </Block>
              <Block
                className={"auto-tabs-button-inner is-absolute"}
                data-auto-tabs-button={"pause-icon"}
                tag={"div"}
              >
                <Block className={"auto-tabs-icon"} tag={"div"}>
                  <Block className={"pause-icon-component"} tag={"div"}>
                    <DOM
                      className={"pause-icon"}
                      fill={"none"}
                      tag={"svg"}
                      viewBox={"0 0 13 22"}
                      width={"100%"}
                      xmlns={"http://www.w3.org/2000/svg"}
                    >
                      <DOM
                        d={"M10.9995 2L10.9995 20"}
                        stroke={"currentColor"}
                        strokeLinecap={"round"}
                        strokeWidth={"4"}
                        tag={"path"}
                      />
                      <DOM
                        d={"M1.99951 2L1.99951 20"}
                        stroke={"currentColor"}
                        strokeLinecap={"round"}
                        strokeWidth={"4"}
                        tag={"path"}
                      />
                    </DOM>
                  </Block>
                </Block>
                <Block className={"auto-tabs-button-text"} tag={"div"}>
                  {"Pause autoplay"}
                </Block>
              </Block>
            </DOM>
            <HtmlEmbed
              className={"autoplay-tabs-custom-js"}
              content={
                '<style>\n/* ============================================\n   AUTO-TABS — pure CSS version\n   3 tabs × 5s = 15s total cycle\n   Adjust everywhere marked /* CHANGE FOR N TABS */\n   ============================================ */\n\n/* ---------- Panes ---------- */\n[class*="auto-tabs-component"] .w-tab-pane {\n  display: block !important;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 1;\n  animation: auto-tabs-pane 15s infinite; /* CHANGE FOR N TABS: 5s × N */\n}\n\n[class*="auto-tabs-component"] .w-tab-pane:nth-child(1) { animation-delay: 0s;  }\n[class*="auto-tabs-component"] .w-tab-pane:nth-child(2) { animation-delay: 5s;  }\n[class*="auto-tabs-component"] .w-tab-pane:nth-child(3) { animation-delay: 10s; }\n/* Add :nth-child(4) { animation-delay: 15s; } etc. for more tabs */\n\n@keyframes auto-tabs-pane {\n  0%      { opacity: 0; visibility: visible; position: relative; z-index: 2; }\n  5.33%   { opacity: 1; }\n  33.33%  { opacity: 1; position: relative; }\n  33.34%  { position: absolute; }\n  38.67%  { opacity: 0; z-index: 1; }\n  100%    { opacity: 0; visibility: hidden; position: absolute; z-index: 1; }\n}\n\n/* ---------- Progress bar ---------- */\n[data-auto-tabs="bar"] {\n  height: 30%;\n  animation: auto-tabs-bar 15s infinite; /* CHANGE FOR N TABS */\n}\n\n[data-auto-tabs="link"]:nth-child(1) [data-auto-tabs="bar"] { animation-delay: 0s;  }\n[data-auto-tabs="link"]:nth-child(2) [data-auto-tabs="bar"] { animation-delay: 5s;  }\n[data-auto-tabs="link"]:nth-child(3) [data-auto-tabs="bar"] { animation-delay: 10s; }\n\n@keyframes auto-tabs-bar {\n  0%     { height: 30%; }\n  33.33% { height: 100%; }\n  33.34% { height: 30%; }\n  100%   { height: 30%; }\n}\n\n/* ---------- Active link description color ---------- */\n[data-auto-tabs="link"] [class*="auto-tabs-description"] {\n  color: inherit;\n  animation: auto-tabs-text 15s infinite; /* CHANGE FOR N TABS */\n}\n\n[data-auto-tabs="link"]:nth-child(1) [class*="auto-tabs-description"] { animation-delay: 0s;  }\n[data-auto-tabs="link"]:nth-child(2) [class*="auto-tabs-description"] { animation-delay: 5s;  }\n[data-auto-tabs="link"]:nth-child(3) [class*="auto-tabs-description"] { animation-delay: 10s; }\n\n@keyframes auto-tabs-text {\n  0%      { color: inherit; }\n  3.33%   { color: #033532; }\n  33.33%  { color: #033532; }\n  36.67%  { color: inherit; }\n  100%    { color: inherit; }\n}\n\n/* ---------- Active number indicator ---------- */\n[data-auto-tabs="link"] [class*="auto-tabs-number-inner"] {\n  animation: auto-tabs-number 15s infinite; /* CHANGE FOR N TABS */\n}\n\n[data-auto-tabs="link"]:nth-child(1) [class*="auto-tabs-number-inner"] { animation-delay: 0s;  }\n[data-auto-tabs="link"]:nth-child(2) [class*="auto-tabs-number-inner"] { animation-delay: 5s;  }\n[data-auto-tabs="link"]:nth-child(3) [class*="auto-tabs-number-inner"] { animation-delay: 10s; }\n\n@keyframes auto-tabs-number {\n  0%, 36.67%, 100% {\n    color: rgba(5, 54, 50, 0.5);\n    background-color: #ffffff;\n    border-color: rgba(3, 53, 50, 0.1);\n  }\n  3.33%, 33.33% {\n    color: #033532;\n    background-color: #C7F50A;\n    border-color: #C7F50A;\n  }\n}\n\n/* ---------- Pause on hover ---------- */\n[class*="auto-tabs-component"]:hover .w-tab-pane,\n[class*="auto-tabs-component"]:hover [data-auto-tabs="bar"],\n[class*="auto-tabs-component"]:hover [class*="auto-tabs-description"],\n[class*="auto-tabs-component"]:hover [class*="auto-tabs-number-inner"] {\n  animation-play-state: paused;\n}\n\n/* ---------- Mobile ---------- */\n@media screen and (max-width: 991px) {\n  [class*="auto-tabs-component"] .w-tab-pane {\n    position: relative;\n    opacity: 1;\n    visibility: visible;\n    animation: none;\n  }\n  [data-auto-tabs="bar"] { display: none !important; }\n  [class*="auto-tabs-description"],\n  [class*="auto-tabs-number-inner"] {\n    animation: none;\n  }\n}\n</style>'
              }
            />
            <Block className={"how-itworks-heading-wrapper"} tag={"div"}>
              <Heading className={"h2"} tag={"h2"}>
                {title2}
              </Heading>
              <Block
                className={"how-it-works-become-a-member-wrapper"}
                tag={"div"}
              >
                <Link
                  button={true}
                  className={"button-yellow-full"}
                  options={link2}
                >
                  {text7}
                </Link>
                <Block className={"contribution-allocation-link"} tag={"div"}>
                  <Block className={"bodysmall"} tag={"div"}>
                    <Link
                      button={false}
                      className={"italics-link-green"}
                      options={link4}
                    >
                      {text8}
                    </Link>
                  </Block>
                  <Image
                    alt={""}
                    className={"arrow-up"}
                    height={"auto"}
                    loading={"lazy"}
                    src={image8}
                    width={"auto"}
                  />
                </Block>
              </Block>
            </Block>
          </Block>
        </BlockContainer>
      </Section>
    </div>
  );
}
